import * as EventEmitter from 'events';

function genEventBus() {
	// eventBus
	const EventEmitterConstructor = EventEmitter.EventEmitter || EventEmitter
	const ee = new EventEmitterConstructor();
	ee.setMaxListeners(0);
	return ee;
}

export default genEventBus;
